import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import { Icon } from '@iconify/react';
import {
  Box,
  Checkbox,
  Chip,
  Divider,
  FormControlLabel,
  FormGroup,
  IconButton,
  MenuItem,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { DeleteButton } from '../../../../components/mui/Buttons/Buttons';
import RemarkPopup from './RemarkPopup';
import MakeNextPayment from './MakeNextPayment';
import CartPaymentLogTbl from './CartPaymentLogTbl';
import CartItemSubjects from './CartItemSubjects';
import HoldAmountForm from './HoldAmountForm';
import CartItemSubjectNew from './CartItemSubjectNew';
import EmiVerification from './FeeAutomation/EmiVerification';
import { useSnackbar } from 'notistack';
import { ta } from 'date-fns/locale';
import OldNextPayment from './OldNextPayment';
import CartItemEdit from './CartEdit/CartItemEdit';

export default function ActionMenu({
  children,
  handleInputChange,
  handleDelete,
  paidItem,
  item,
  totalCourses,
  update,
  paid,
  addNewPayment,
  paymentProcessingItems,
  paymentProcessing,
  setAvailableCartItems,
  setTotalCourses,
  paymentRecieptValidation,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [emiOpen, setEmiOpen] = React.useState(false);
  const [oldpaying, setOldPaying] = React.useState(item.paidAmt);
  const [emiState, setEmiState] = React.useState({
    proFee: item.processingFee || false,
    emiAmt: item.paidAmt || '',
  });
  const handleEmiStateSubmit = () => {
    if (!emiState.emiAmt) {
      enqueueSnackbar('Please enter EMI amount', { variant: 'error' });
      return;
    }
    const processingFee = { target: { value: emiState.proFee } };
    const emiPaidAmt = { target: { value: emiState.emiAmt } };
    const emiStatus = { target: { value: true } };
    handleInputChange(emiPaidAmt, item.id, 'paidAmt');
    handleInputChange(processingFee, item.id, 'processingFee');
    handleInputChange(emiStatus, item.id, 'emi');

    setEmiOpen(false);
  };
  // useEffect(() => {
  //   if (!item.emi) {
  //     setOldPaying(item.paidAmt);
  //   }
  // }, [item]);

  const handleEmiChange = (e) => {
    if (!item.emi) {
      setEmiOpen(true);
      setOldPaying(item.paidAmt);
    } else {
      const paidAmts = { target: { value: oldpaying } };
      handleInputChange(e, item.id, 'emi');
      handleInputChange(paidAmts, item.id, 'paidAmt');
      handleInputChange(e, item.id, 'processingFee');

      // const rem = { target: { value: false } };
      // handleInputChange(rem, item.id, "processingFee");
    }
    // alert(
    //   "EMI feature is under development, please contact support for more details."
    // );
  };

  return (
    <div>
      <Button
        sx={{ borderRadius: 10 }}
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <Icon icon="iconamoon:menu-kebab-vertical-fill" height={22} width={22} />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        variant="menu"
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', pb: 1 }}>
            <Chip
              icon={
                <IconButton
                  sx={{
                    color: 'text.primary',
                    animation: 'spin 5s linear infinite',
                    '@keyframes spin': {
                      '0%': {
                        transform: 'rotate(360deg)',
                      },
                      '100%': {
                        transform: 'rotate(0deg)',
                      },
                    },
                  }}
                >
                  <Icon icon="solar:settings-outline" />
                </IconButton>
              }
              variant="outlined"
              size="small"
              color="primary"
              label="Actions"
            />
          </Box>
          <Divider sx={{ borderStyle: 'dashed', borderBottomWidth: 2 }} />
        </Box>
        {children}
        <Box sx={{ pt: 1 }} key={item.id}>
          {/* {update ? null : ( */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.3 }}
          >
            <MenuItem>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={paid ? true : false}
                    checked={item.wishList || false}
                    onClick={() => setAnchorEl(null)}
                    onChange={(e) => handleInputChange(e, item.id, 'wishList')}
                  />
                }
                label="wish list"
              />
            </MenuItem>
          </motion.div>
          {/* )} */}

          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.3 }}
          >
            {/* <MenuItem>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Switch
                      checked={item.admissionFee === 0 ? false : true || false}
                      // onClick={() => setAnchorEl(null)}
                      onChange={(e) =>
                        handleInputChange(e, item.id, "admissionFee")
                      }
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  }
                  label="Admission Fee"
                />
              </FormGroup>
            </MenuItem> */}
            <MenuItem>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Switch
                      disabled={
                        paid || update ? true : item.selectedCurrency === 2 ? true : item.paidAmt ? false : true
                      }
                      checked={item.emi || false}
                      // onClick={() => setAnchorEl(null)}
                      // onChange={(e) => handleInputChange(e, item.id, "emi")}
                      onChange={handleEmiChange}
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  }
                  label="EMI"
                />
              </FormGroup>
            </MenuItem>
          </motion.div>
          <EmiVerification
            open={emiOpen}
            setOpen={setEmiOpen}
            setEmiState={setEmiState}
            emiState={emiState}
            item={item}
            handleEmiStateSubmit={handleEmiStateSubmit}
          />
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.3 }}
          >
            <MenuItem>
              <RemarkPopup
                paid={paid}
                update={update}
                handleClose={handleClose}
                item={item}
                handleInputChange={handleInputChange}
              />
            </MenuItem>
          </motion.div>

          {addNewPayment && paidItem.emi != 1 ? (
            <motion.div
              initial={{ opacity: 0, x: -60 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3 }}
            >
              {paidItem.nextPaymentPermission ? (
                <MenuItem>
                  {paidItem.selectedOption ? (
                    <MakeNextPayment
                      handleClose={handleClose}
                      paidItem={paidItem}
                      paid={paid}
                      paymentRecieptValidation={paymentRecieptValidation}
                    />
                  ) : (
                    <OldNextPayment
                      handleClose={handleClose}
                      paidItem={paidItem}
                      paid={paid}
                      paymentRecieptValidation={paymentRecieptValidation}
                    />
                  )}
                </MenuItem>
              ) : null}
            </motion.div>
          ) : null}
          {paid || paymentProcessing ? (
            <motion.div
              initial={{ opacity: 0, x: -60 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3 }}
            >
              <MenuItem>
                <CartPaymentLogTbl
                  item={item}
                  paid={paid}
                  paymentProcessing={paymentProcessing}
                  paidItem={paidItem}
                  paymentProcessingItems={paymentProcessingItems}
                />
              </MenuItem>
            </motion.div>
          ) : null}

          <motion.div
            initial={{ opacity: 0, x: -60 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.3 }}
          >
            <MenuItem>
              {/* <CartItemSubjects
                item={item}
                update={update}
                setAvailableCartItems={setAvailableCartItems}
                // handleInputChange={handleInputChange}
                setTotalCourses={setTotalCourses}
                handleClose={handleClose}
              /> */}
              <CartItemSubjectNew
                item={item}
                update={update}
                setAvailableCartItems={setAvailableCartItems}
                // handleInputChange={handleInputChange}
                setTotalCourses={setTotalCourses}
                handleClose={handleClose}
              />
            </MenuItem>
          </motion.div>
          {update ? (
            <motion.div
              initial={{ opacity: 0, x: -60 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3 }}
            >
              <HoldAmountForm item={item} />
            </motion.div>
          ) : null}
          {/* <motion.div
            initial={{ opacity: 0, x: -60 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.3 }}
          >
            <MenuItem>
              <CartItemEdit />
            </MenuItem>
          </motion.div> */}

          {paid || paymentProcessing ? null : (
            <motion.div
              initial={{ opacity: 0, x: -60 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3 }}
            >
              <MenuItem>
                <DeleteButton
                  size="small"
                  action={() => {
                    handleDelete(item.id, item.cartId);
                    setAnchorEl(null);
                  }}
                >
                  Delete
                </DeleteButton>
              </MenuItem>
            </motion.div>
          )}
        </Box>
      </Menu>
    </div>
  );
}
